export const landingConstants = {
  subHeading: `### Please select from the options below.`,
  activateCardButtonText:
    process.env.REACT_APP_ACTIVATE_BUTTON_TEXT ?? `Activate my card`,
  balanceButtonText:
    process.env.REACT_APP_BALANCE_BUTTON_TEXT ?? `Balance Check`,
};
